import { AxiosResponse } from "axios";
import { ApiResponseStatusEnum } from "./ApiResponseStatusEnum";

export class ApiGenericResponse {
    responseStatus: ApiResponseStatusEnum;
    errorMessage: string;
    payload?: any;
    message: string;
    responseString: string;

    constructor(response: AxiosResponse) {
        // console.log("response:", response);
        this.responseStatus = ApiResponseStatusEnum.Unknown;
        if (response && response.status) {
            this.responseStatus = this.fillResponseStatus(response.status);
        }
        if (response.data) {
            this.errorMessage = response.data.ExceptionMessage ? response.data.ExceptionMessage : response.data.errorMessage ? response.data.errorMessage : "";
            this.message = response.data.Message;
            this.responseString = response.data.ResponseString;
        }
    }

    private fillResponseStatus(status): ApiResponseStatusEnum {
        switch (status) {
            case 200: {
                return ApiResponseStatusEnum.Success;
            }
            case 204: {
                return ApiResponseStatusEnum.Success;
            }
            case 401: {
                return ApiResponseStatusEnum.UnAuthorized;
            }
            case 500: {
                return ApiResponseStatusEnum.Error;
            }
            case 503: {
                return ApiResponseStatusEnum.NotReady;
            }
            default: {
                return ApiResponseStatusEnum.Error;
            }
        }
    }
}
